import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ShieldCheck, SlidersHorizontal } from "lucide-react";

import { useAuth } from "@/features/Auth/state/AuthContext";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/shared/components/ui/tabs";
import { AvatarUpload } from "./AvatarUpload";
import { LanguageSettings } from "./LanguageSettings";
import { ProfileInfo } from "./ProfileInfo";

/**
 * O perfil: cabeçalho de identidade e, abaixo dele, as abas (AB#85634, AC23).
 *
 * As abas ficam **sob o cabeçalho** porque é isso que elas são — navegação
 * dentro da página de uma pessoa, e não a página inteira. Com elas no topo, o
 * avatar e o nome entravam como conteúdo de uma aba, e a identidade de quem
 * está ali sumia ao trocar de aba.
 *
 * Nome e cargo são editados no próprio cabeçalho, onde aparecem. Antes havia uma
 * linha mostrando o nome e, logo abaixo, outra linha mostrando o mesmo nome para
 * editá-lo.
 */
export default function ProfileView() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const { t } = useTranslation();

  if (!user) {
    navigate("/login");
    return null;
  }

  return (
    <div className="w-full animate-fade-in">
      {/* Identidade: quem está nesta página. Fica fora das abas, porque vale
          para todas elas. */}
      <div className="flex items-center gap-5 pb-6">
        <div className="shrink-0">
          <AvatarUpload />
        </div>
        <ProfileInfo section="header" />

        {/* O idioma fica no cabeçalho, à direita: é a preferência que se troca
            com mais frequência e a que menos depende de contexto. SEM bandeira —
            bandeira é país, não idioma, e o nome escrito no próprio idioma é o
            que quem procura o seu reconhece numa tela que não entende. */}
        <div className="ml-auto shrink-0 self-start">
          <LanguageSettings variant="compact" />
        </div>
      </div>

      <Tabs defaultValue="preferences" className="w-full">
        <div className="flex items-center justify-between border-b">
          <TabsList>
            <TabsTrigger value="preferences">
              <SlidersHorizontal className="mr-2 h-4 w-4" />
              {t("profile.tabs.preferences")}
            </TabsTrigger>
            <TabsTrigger value="security">
              <ShieldCheck className="mr-2 h-4 w-4" />
              {t("profile.tabs.security")}
            </TabsTrigger>
          </TabsList>
        </div>

        {/* O limite de largura é o do editor de instruções, que é o conteúdo mais
            largo de que alguma aba precisa. Igual em todas, para o bloco não
            encolher e crescer a cada troca de aba. */}
        <TabsContent value="preferences" className="mt-8">
          <div className="max-w-4xl space-y-6">
            <ProfileInfo section="preferences" />
          </div>
        </TabsContent>


        <TabsContent value="security" className="mt-8">
          <div className="max-w-4xl">
            <ProfileInfo section="security" />
          </div>
        </TabsContent>
      </Tabs>
    </div>
  );
}
